import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { AppHelper } from "../appHelper.js";
import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp.js";
import { General } from "../../siteManagement/general.js";
import { Sheet, SheetEventType } from "../../siteManagement/sheet.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { Config } from "../core/config/config.js";
import { ResourceStatusSetting } from "../resourcePlanningScheduler/resourcePlanningScheduler.js";
import { KeyValuePair } from "../commonInterfaces.js";
import React from "react";
export class FavoriteFilterHelper {
    public static editFavorite = (id: string, isGlobal: boolean) => {
        const url = `FavoriteFilter/GetConfigurationView?id=${id}`;
        return FavoriteFilterHelper.openSheet(url, isGlobal);
    }

    public static createGlobal = () => {
        const url = "FavoriteFilter/CreateGlobal";
        return FavoriteFilterHelper.openSheet(url, true);
    }

    private static openSheet = (entityUrl: string, isGlobal: boolean) => {
        return new Promise<FavoriteFilterSheetResult>(async (resolve, reject) => {
            const [entityResult, baseMetaData, specificMetaData, flagsResult, mainGroups, groups, locations, resTypes, codes] = await Promise.all([
                HTTPService.get<JsonResultClass<IFavoriteFilterConfigruationView>>(entityUrl),
                Helper.getMetaData("favoriteFilterConfiguration"),
                Helper.getMetaData(isGlobal ? "globalFavoriteFilterConfiguration" : "userFavoriteFilterConfiguration"),
                HTTPService.get<JsonResultClass<[]>>("PlanningBoardFlag/GetAllFlags"),
                HTTPService.get("ResourcePlanningLookup/GetObergruppen"),
                HTTPService.get("ResourcePlanningLookup/GetGruppen"),
                HTTPService.get("ResourceLookup/GetLocations"),
                HTTPService.get("ResourceLookup/GetResstypen"),
                HTTPService.get("ResourcePlanningLookup/GetKennungen")
            ]);
            if (entityResult.Code != 0) {
                reject(entityResult.Message);
            }

            const metaData = baseMetaData;
            metaData.tabs.unshift(specificMetaData.tabs[0]);


            let flags = [];
            if (flagsResult.Code == 0) {
                flags = flagsResult.Data;
            }

            const sheet = General.Sheet.Manager.createSheet();
            const props: EditFavoriteFilterProps = {
                resourceStatusEnabled: Helper.hasValue(entityResult.AdditionalData) ? entityResult.AdditionalData["resourceStatusEnabled"] : [],
                resourceTypesEnabled: Helper.hasValue(entityResult.AdditionalData) ? entityResult.AdditionalData["resourceTypesEnabled"] : [],
                resstandEnabled: Helper.hasValue(entityResult.AdditionalData) ? entityResult.AdditionalData["resstandEnabled"] : [],
                context: {
                    contextType: "favoriteFilter",
                },
                dataSources: {
                    mainGroups: mainGroups,
                    groups: groups,
                    locations: locations,
                    resTypes: resTypes,
                    codes: codes,
                    zoomModes: [
                        {
                            text: Helper.getTranslation("WebSMS.FlexTime.Hours"),
                            value: 0
                        },
                        {
                            text: Helper.getTranslation("WebSMS.Common.DateTime.Tage"),
                            value: 1
                        },
                        {
                            text: Helper.getTranslation("Kapazitaet.Woche"),
                            value: 2
                        },
                        {
                            text: Helper.getTranslation("Kapazitaet.Monat"),
                            value: 3
                        }
                    ],
                    flagModes: [
                        {
                            text: Helper.getTranslation("WebSMS.DataExchangeModule.File.Inactiv"),
                            value: 0
                        },
                        {
                            text: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Flags.CellInFlagColor"),
                            value: 1
                        },
                        {
                            text: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Flags.AssignmentsInFlagColor"),
                            value: 2
                        }
                    ],
                    grouping: [
                        {
                            text: Helper.getTranslation("Field.Enum.RosterOrigin.Resource"),
                            value: 0
                        },
                        {
                            text: Helper.getTranslation("Adresse.Adressen"),
                            value: 1
                        },
                        {
                            text: Helper.getTranslation("Navigation.Projekte"),
                            value: 2
                        },
                        {
                            text: Helper.getTranslation("Field.fstasks.machines"),
                            value: 3
                        }
                    ],
                    flags: flags,
                    addresses: Helper.hasValue(entityResult.AdditionalData) ? entityResult.AdditionalData["addresses"] : [],
                    projects: Helper.hasValue(entityResult.AdditionalData) ? entityResult.AdditionalData["projects"] : [],
                    resources: Helper.hasValue(entityResult.AdditionalData) ? entityResult.AdditionalData["resources"] : [],
                    resourceStatus: [
                        {
                            Key: ResourceStatusSetting.All,
                            Value: Helper.getTranslation("Standard.Alle")
                        },
                        {
                            Key: ResourceStatusSetting.Active,
                            Value: Helper.getTranslation("Ressource.Aktiv")
                        },
                        {
                            Key: ResourceStatusSetting.Inactive,
                            Value: Helper.getTranslation("Ressource.Passiv")
                        }
                    ]
                },
                entity: entityResult.Data,
                isWindow: false,
                metadata: metaData,
                onClose: (resultType: FavoriteFilterSheetResult) => {
                    resolve(resultType);
                }
            };
            sheet.show(() => {
                sheet.mountContent(EditFavoriteFilter, props);
            })
        });
    }


    public static delete = (id: string) => {
        return new Promise<boolean>(async (resolve) => {
            const result = await HTTPService.get<JsonResultClass>(`FavoriteFilter/Delete?id=${id}`);
            resolve(result.Code === 0);
        })
    }
}

export enum FavoriteFilterSheetResult {
    JustClosed = 0,
    SavedSuccessfully = 1,
    DeletedSuccessfully = 2
}

class EditFavoriteFilter extends React.Component<EditFavoriteFilterProps, { resultType: FavoriteFilterSheetResult }> {
    common = new AppHelper();
    showClearButton = false;

    resourceStatusEnabled: boolean;
    resourceTypesEnabled: boolean;
    resstandEnabled: boolean;
    projectFilterActive: boolean;

    private sheet: Sheet;

    constructor(props: EditFavoriteFilterProps) {
        super(props)

        this.setGlobalOptions()

        this.common.enableHooks = false;
        this.common.init(this);




        this.state = {
            resultType: FavoriteFilterSheetResult.JustClosed
        }
        this.initApp();
    }

    private setGlobalOptions = () => {
        this.resourceStatusEnabled = this.props.resourceStatusEnabled;
        this.resourceTypesEnabled = this.props.resourceTypesEnabled;
        this.resstandEnabled = this.props.resstandEnabled;
        const projNrs = (this.props.entity.Settings as any).ProjNrs;
        if (Helper.hasValue(projNrs) && Array.isArray(projNrs)) {
            this.projectFilterActive = projNrs.length > 0
        }
    }

    private initApp = () => {
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.sheet.bind(SheetEventType.Close, () => {
            this.props.onClose(this.state.resultType);
        });
        $(window).on("tabStripTabSelected", (_, data: { index: number }) => {
            this.showClearButton = data.index === 1;
            this.setState({});
        });
        this.setTitle();
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Settings.FixedCellWidth":
                if ((value as boolean))
                    this.handleFieldChange({ model: "entity.Settings.CellWidth" }, null);
                break;
            case "entity.Settings.Grouping":
                if (value > 0) {
                    this.handleFieldChange({ model: "entity.Settings.DisplayCapacityChart" }, false);
                    this.handleFieldChange({ model: "entity.Settings.ShowDegreeOfCompletion" }, false);
                    this.handleFieldChange({ model: "entity.Settings.FlagMode" }, 0);
                    this.handleFieldChange({ model: "entity.Settings.AssignmentMoveHorizontalFixed" }, false);
                    this.handleFieldChange({ model: "entity.Settings.AssignmentMoveHorizontalFixed" }, false);
                }
                break;
            case "entity.Settings.ShowProjectColor":
                if ((value as boolean)) {
                    this.handleFieldChange({ model: "entity.Settings.FlagMode" }, 0);
                    this.handleFieldChange({ model: "entity.Settings.SlaViewActive" }, false);
                    this.handleFieldChange({ model: "entity.Settings.AssignmentGroupingViewActive" }, false);
                }
                break;
            case "entity.Settings.FlagMode":
                if (value > 0) {
                    this.handleFieldChange({ model: "entity.Settings.SlaViewActive" }, false);
                    this.handleFieldChange({ model: "entity.Settings.ShowProjectColor" }, false);
                    this.handleFieldChange({ model: "entity.Settings.AssignmentGroupingViewActive" }, false);
                }
                break;
            case "entity.Settings.SlaViewActive":
                if ((value as boolean)) {
                    this.handleFieldChange({ model: "entity.Settings.FlagMode" }, 0);
                    this.handleFieldChange({ model: "entity.Settings.ShowProjectColor" }, false);
                    this.handleFieldChange({ model: "entity.Settings.AssignmentGroupingViewActive" }, false);
                }
                break;
            case "entity.Settings.AssignmentGroupingViewActive":
                this.handleFieldChange({ model: "entity.Settings.FlagMode" }, 0);
                this.handleFieldChange({ model: "entity.Settings.SlaViewActive" }, false);
                this.handleFieldChange({ model: "entity.Settings.ShowProjectColor" }, false);
                break;
            case "entity.Settings.ShowOnlyWorktime":
                if ((value as boolean)) {
                    this.handleFieldChange({ model: "entity.Settings.DisplayCapacityChart" }, false);
                }
                break;
            case "entity.Settings.AssignmentMoveHorizontalFixed":
                if ((value as boolean)) {
                    this.handleFieldChange({ model: "entity.Settings.AssignmentMoveVerticalFixed" }, false);
                }
                break;
            case "entity.Settings.AssignmentMoveVerticalFixed":
                if ((value as boolean)) {
                    this.handleFieldChange({ model: "entity.Settings.AssignmentMoveHorizontalFixed" }, false);
                }
                break;
            case "entity.Settings.ProjNrs":
                let projectFilterActive = false;
                if (Helper.hasValue(value) && Array.isArray(value) && value.length > 0) {
                    projectFilterActive = true;
                } else {
                    this.handleFieldChange({ model: "entity.Settings.ProjectFilterShowAllAssignments" }, false);
                }
                this.projectFilterActive = projectFilterActive;
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }



    clearFilters = () => {
        const ignoredProps = ["TimeResolutionType", "FitToScreen", "CellWidth", "Period"];
        Object.keys(this.props.entity.Settings)
            .filter(prop => ignoredProps.findIndex(iProp => iProp == prop) == -1)
            .forEach((prop) => {
                const value = this.props.entity.Settings[prop];
                switch (typeof value) {
                    case 'boolean':
                        this.handleFieldChange({ model: `entity.Settings.${prop}` }, false);
                        break;
                    case 'number':
                        this.handleFieldChange({ model: `entity.Settings.${prop}` }, 0);
                        break;
                    case 'object':
                        if (Array.isArray(value))
                            this.handleFieldChange({ model: `entity.Settings.${prop}` }, []);
                        break;
                }
            });
    }

    save = async () => {
        if (!this.common.validate()) {
            return;
        }
        const url: string = this.props.entity.IsGlobal ? "FavoriteFilter/SaveGlobal" : "FavoriteFilter/SaveUser";
        const result = await HTTPService.post<JsonResultClass<string>>(url, { configurationView: this.props.entity });
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"));
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
        if (this.props.entity.IsNew) {
            this.props.entity.IsNew = false;
            this.props.entity.Id = result.Data;
        }
        this.common.handlePostSave(result.Code === 0, false);
        this.setState({
            resultType: FavoriteFilterSheetResult.SavedSuccessfully
        });
    }

    remove = async () => {
        const ok = await DialogHelper.confirm(__internal_translations["Standard.Msg.Loeschen"]);
        if (ok) {
            const result = await HTTPService.get<JsonResultClass>(`FavoriteFilter/Delete?id=${this.props.entity.Id}`);
            if (result.Code === 0) {
                this.setState({
                    resultType: FavoriteFilterSheetResult.DeletedSuccessfully
                }, () => {
                    this.sheet.hide();
                })
            }
        }
    }

    private setTitle = () => {
        let title = Helper.isNullOrEmpty(this.props.entity.FallbackName) ? "" : this.props.entity.FallbackName;


        if (Helper.hasValue(this.props.entity.NameTranslations)) {
            const translation = this.props.entity.NameTranslations.find(f => f.Key == Config.user.languageId);
            if (Helper.hasValue(translation) && !Helper.isNullOrEmpty(translation.Value)) {
                title = translation.Value;
            }
        }
        this.sheet.setTitle(title);
    }


    componentDidUpdate() {
        this.setTitle();
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface EditFavoriteFilterProps extends AppBaseProps {
    entity: IFavoriteFilterConfigruationView;
    onClose: (resultType: FavoriteFilterSheetResult) => void;
    resourceStatusEnabled: boolean;
    resourceTypesEnabled: boolean;
    resstandEnabled: boolean;
}

interface IFavoriteFilterConfigruationView extends Entity {
    Id: string;
    FallbackName: string;
    FallbackDescription: string;
    Settings: {};
    IsGlobal: boolean;
    NameTranslations: KeyValuePair<number, string>[];

}

